import React from 'react';
import { SidebarTrigger } from '../ui/sidebar';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '../ui/breadcrumb';
import { useBreadcrumbs } from '../../app/breadcrumb-provider';

export const PageHeader: React.FC = () => {
  const { breadcrumbs, headerBorder, headerActions, rightHeaderActions } = useBreadcrumbs();

  return (
    <header className={`flex h-16 shrink-0 items-center gap-2 px-4 ${headerBorder ? 'border-b' : ''}`}>
      <div className="flex items-center gap-2 flex-1 min-w-0">
        <SidebarTrigger className="-ml-1" />
        <div className="h-4 w-px bg-border mx-2" />
        <Breadcrumb>
          <BreadcrumbList>
            {breadcrumbs.map((item, index) => (
              <React.Fragment key={index}>
                <BreadcrumbItem>
                  {index === breadcrumbs.length - 1 ? (
                    <BreadcrumbPage>{item.label}</BreadcrumbPage>
                  ) : item.href ? (
                    <BreadcrumbLink href={item.href}>{item.label}</BreadcrumbLink>
                  ) : (
                    <span>{item.label}</span>
                  )}
                </BreadcrumbItem>
                {index < breadcrumbs.length - 1 && (<BreadcrumbSeparator />)}
              </React.Fragment>
            ))}
          </BreadcrumbList>
        </Breadcrumb>

        {headerActions && (
          <div className="ml-2 flex items-center gap-2">
            {headerActions}
          </div>
        )}
      </div>

      {rightHeaderActions && (
        <div className="flex items-center gap-2">
          {rightHeaderActions}
        </div>
      )}
    </header>
  );
};
